<template>
  <div id="profile" class="bg-push-lightgray">
    <div class="container mx-auto h-screen">
      <div class="w-full flex justify-center">
        <div class="flex align md:w-1/2 w-full">
          <div class="w-full border-1 rounded-md p-4 mt-10 bg-white">
            <b class="text-push-orange text-4xl justify-center flex"
              >Your Account</b
            >
            <!-- Name Field -->
            <div class="bg-white mt-10 relative">
              <i class="far fa-user mr-2"></i>
              <b class="text-lg" v-if="nameState == 'default'"
                >Name: {{ user.profile.name }}</b
              >
              <input
                v-if="nameState == 'edit'"
                class="text-lg"
                :placeholder="this.user.profile.name"
                v-model="nameField"
              />
              <i
                v-if="nameState == 'default'"
                class="far fa-edit absolute mt-1 right-0 hover:opacity-50"
                @click="editNameMode"
              ></i>
              <i
                v-if="nameState == 'edit'"
                class="fas fa-check absolute mt-1 right-0 hover:opacity-50"
                @click="editName"
              ></i>
            </div>
            <!-- Email Field -->
            <div class="bg-white mt-4 relative">
              <i class="far fa-user mr-2"></i>
              <b class="text-lg" v-if="emailState == 'default'"
                >Email: {{ user.profile.email }}</b
              >
              <input
                v-if="emailState == 'edit'"
                class="text-lg"
                :placeholder="this.user.profile.email"
                v-model="emailField"
              />
              <i
                v-if="emailState == 'default'"
                class="far fa-edit absolute mt-1 right-0 hover:opacity-50"
                @click="editEmailMode"
              ></i>
              <i
                v-if="emailState == 'edit'"
                class="fas fa-check absolute mt-1 right-0 hover:opacity-50"
                @click="editEmail"
              ></i>
            </div>
            <!-- Company Field -->
            <div class="bg-white mt-4 relative">
              <i class="far fa-user mr-2"></i>
              <b class="text-lg" v-if="companyState == 'default'"
                >Company: {{ user.profile.company }}</b
              >
              <input
                v-if="companyState == 'edit'"
                class="text-lg"
                :placeholder="this.user.profile.company"
                v-model="companyField"
              />
              <i
                v-if="companyState == 'default'"
                class="far fa-edit absolute mt-1 right-0 hover:opacity-50"
                @click="editCompanyMode"
              ></i>
              <i
                v-if="companyState == 'edit'"
                class="fas fa-check absolute mt-1 right-0 hover:opacity-50"
                @click="editCompany"
              ></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as firebase from "firebase/app";
import { mapState } from "vuex";
export default {
  data() {
    return {
      nameState: "default",
      emailState: "default",
      companyState: "default",
      nameField: "",
      emailField: "",
      companyField: ""
    };
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    ...mapState({
      user: "user"
    })
  },
  methods: {
    editNameMode() {
      this.nameState = "edit";
    },
    editEmailMode() {
      this.emailState = "edit";
    },
    editCompanyMode() {
      this.companyState = "edit";
    },

    editName() {
      var firestore = firebase.firestore();
      var uid = this.user.data.uid;
      var docRef = firestore.doc("users/" + uid);
      // Set the "capital" field of the city 'DC'
      docRef.update({
        name: this.nameField
      });
      this.nameState = "default";
    },

    editEmail() {
      var firestore = firebase.firestore();
      var uid = this.user.data.uid;
      var docRef = firestore.doc("users/" + uid);
      // Set the "capital" field of the city 'DC'
      docRef.update({
        email: this.emailField
      });
      this.emailState = "default";
    },

    editCompany() {
      var firestore = firebase.firestore();
      var uid = this.user.data.uid;
      var docRef = firestore.doc("users/" + uid);
      // Set the "capital" field of the city 'DC'
      docRef.update({
        company: this.companyField
      });
      this.companyState = "default";
    }
  }
};
</script>

<style></style>
